export const SmartFilenameParser = {
  parse: (filename) => {
    if (!filename) return null;
    const name = filename.replace(/\.pdf$/i, '');
    const parts = name.split(' - '); // Separador estrito: "Espaço Hífen Espaço"

    // Cenário Ideal: Autor - Ano - Título
    if (parts.length >= 3) {
      const author = parts[0].trim();
      const yearRaw = parts[1].trim();
      const title = parts.slice(2).join(' - ').trim();
      const year = /^\d{4}$/.test(yearRaw) ? yearRaw : '';
      return { author, year, title, success: true };
    }
    // Cenário Alternativo: Autor - Título
    if (parts.length === 2) {
      return { author: parts[0].trim(), year: '', title: parts[1].trim(), success: true };
    }
    // Fallback
    return { author: '', year: '', title: name, success: false };
  }
};